<template>
  <div fluid :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : 'px-3'">
    <v-col cols="12" class="px-3 mb-2">
      <v-row>
        <!-- Id denuncia y contraseña -->
        <v-col cols="12" md="7">
          <v-text-field v-model="dAuxId" 
                        :id="('dAuxId')" 
                        :label="$t('compDetails.complaintId')+'*'"
                        item-color="datPrimary" 
                        color="datPrimary" 
                        hide-details
                        class="mt-0" 
                        />
        </v-col>
        <v-col v-if="!dShowRecoverInfo" cols="12" md="5">
          <v-text-field v-model="dComplaintPass" 
                        :id="('dComplaintPass')"  
                        :label="$t('compDetails.password')+'*'"
                        item-color="datPrimary" 
                        color="datPrimary" 
                        hide-details
                        class="mt-0" 
                        />
          <v-col cols="12" class="text-right forgotPassword my-auto pt-3">
            <p class="forgotPassword" @click="fRecoverInfoModal">{{ $t('compDetails.passwordRecov') }}</p>
          </v-col>
        </v-col>
        <!-- Recuperación de contraseña -->
        <v-col v-if="dShowRecoverInfo" cols="12"  md="6">
          <v-autocomplete v-model="dSecQuestion"
                          :label="$t('compDetails.secQuestion')+'*'" 
                          :items="dSecQuestions"           
                          item-color="datPrimary" 
                          color="datPrimary"
                          hide-details  
                          class="mt-0"/>
        </v-col>
        <v-col v-if="dShowRecoverInfo" cols="12" md="6">
          <v-text-field v-model="dSecAnswer" 
                        :id="('dSecAnswer')"  
                        :label="$t('compDetails.secAnswer')+'*'"
                        item-color="datPrimary" 
                        color="datPrimary" 
                        class="mt-0" 
                        />
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col v-if="dShowRecoverInfo" cols="auto" class="px-2">
          <v-btn depressed class="datPrimaryBtnOut" @click="fClose()">{{$t("btn.backTo")}}</v-btn>
        </v-col>
        <v-col cols="auto" class="px-2">
          <v-btn depressed class="datPrimaryBtn" @click="fGetAnonymComplaint">{{$t("btn.search")}}</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>

// Servicios
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

export default {
  
  mixins: [mxCanalDenuncias],

  data () {
    return {
      dComplaintPass: null,
      dAuxId: null,
      dShowRecoverInfo: false,
      dSecQuestion: null,
      dSecAnswer: null,
      dExternalOrigin: localStorage.getItem("externOrigin") 
    }
  },

  props:{
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    },    
  },

  methods: {
    // Comprueba que los campos se han rellenado correctamente
    fCheckValues(){
      let error 
      if(this.fCheckSingleValue(this.dAuxId)){
        error = this.$t('datError.noId')
      }else if(!this.dShowRecoverInfo && this.fCheckSingleValue(this.dComplaintPass)){
        error = this.$t('datError.noPassword')
      }else if(this.dShowRecoverInfo && this.fCheckSingleValue(this.dSecQuestion)){
        error = this.$t('datError.noSecQuestion')
      }else if(this.dShowRecoverInfo && this.fCheckSingleValue(this.dSecAnswer)){
        error = this.$t('datError.noSecAnswer')
      }
      return error 
    },

    fRecoverInfoModal(){
      this.dShowRecoverInfo = !this.dShowRecoverInfo
    },

    // Recupera la denuncia anónima
    fGetAnonymComplaint(){
      const payload = {
        complaintPass: this.dComplaintPass,
        auxId: this.dAuxId,
        secQuestion: this.dSecQuestion,
        secAnswer: this.dSecAnswer,
        recoverInfo: this.dShowRecoverInfo ? 'S' : 'N'
      }
      let error = this.fCheckValues() 

      if(error){
        this.fSnackbarError(error, this.pShowSnackbar)

      }else if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getAnonymComplaint(payload).then((response) =>{
          this.fCheckResponse(response)
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })

      }else{
        ServiceEcomplaints.getAnonymComplaint(payload).then((response) =>{
          this.fCheckResponse(response)
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }
    },

    // Cierra el componente de logs
    fClose(complaintInfo){
      if (complaintInfo){
        this.$emit('close', complaintInfo)
      } else if(this.dShowRecoverInfo){
        this.dShowRecoverInfo = !this.dShowRecoverInfo
      } else {
        this.$emit('close')
      }
    },

    fCheckResponse(response){
      if (response.statusCode == '200' && response.dataRes[0]){
        this.fClose(response.dataRes[0])
      }else{
        this.fSnackbarError(this.$t('datGeneric.noData'), this.pShowSnackbar)
      }
    }
  }
}
</script>

 